type WithLotteryName = { lotteryName: string };
type WithDrawingDate = { drawingDate?: number | string };

function sortAlphabetically<T extends WithLotteryName>(items: T[]): T[] {
  return items.toSorted((aa, bb) => aa.lotteryName.localeCompare(bb.lotteryName));
}

function sortByDrawingDateDesc<T extends WithDrawingDate>(items: T[]): T[] {
  return [...items].toSorted((aa, bb) => Number(bb.drawingDate ?? 0) - Number(aa.drawingDate ?? 0));
}

export { sortAlphabetically, sortByDrawingDateDesc };
